import { render, staticRenderFns } from "./RepairLinkMobile.vue?vue&type=template&id=2998c9af"
import script from "./RepairLinkMobile.vue?vue&type=script&lang=js"
export * from "./RepairLinkMobile.vue?vue&type=script&lang=js"
import style0 from "./RepairLinkMobile.vue?vue&type=style&index=0&id=2998c9af&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports